<template>
  <div class="builder-topbar">
    <div class="builder-topbar-left">
      <h1>🎨 UI Builder</h1>
    </div>
    
    <div class="builder-topbar-center">
      <div class="responsive-modes">
        <button 
          v-for="mode in modes" 
          :key="mode.value"
          :class="['mode-btn', { active: responsiveMode === mode.value }]"
          @click="$emit('change-mode', mode.value)"
          :title="mode.label"
        >
          <span class="mode-icon">{{ mode.icon }}</span>
          <span class="mode-label">{{ mode.label }}</span>
        </button>
      </div>
    </div>
    
    <div class="builder-topbar-right">
      <button 
        class="btn btn-outline btn-sm" 
        :disabled="!canUndo"
        @click="$emit('undo')"
        title="Undo (Ctrl+Z)"
      >
        ↶ Undo
      </button>
      <button 
        class="btn btn-outline btn-sm" 
        :disabled="!canRedo"
        @click="$emit('redo')"
        title="Redo (Ctrl+Y)"
      >
        ↷ Redo
      </button>
      <button 
        class="btn btn-primary btn-sm" 
        :disabled="isSaving"
        @click="$emit('save')"
        title="Save structure"
      >
        <span v-if="isSaving" class="loading-spinner"></span>
        <span v-else>💾</span>
        Save
      </button>
      <button 
        class="btn btn-success btn-sm"
        @click="$emit('publish')"
        title="Publish structure"
      >
        🚀 Publish
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  responsiveMode: {
    type: String,
    default: 'desktop'
  },
  canUndo: {
    type: Boolean,
    default: false
  },
  canRedo: {
    type: Boolean,
    default: false
  },
  isSaving: {
    type: Boolean,
    default: false
  }
});

defineEmits(['change-mode', 'undo', 'redo', 'save', 'publish']);

const modes = [
  { value: 'desktop', label: 'Desktop', icon: '🖥️' },
  { value: 'tablet', label: 'Tablet', icon: '📱' },
  { value: 'mobile', label: 'Mobile', icon: '📱' }
];
</script>

<style scoped>
.mode-icon {
  display: inline-block;
  margin-right: 4px;
}

@media (max-width: 768px) {
  .mode-label {
    display: none;
  }
}
</style>

